// Interface

import util from '@/utils/classToObject'
import { IRoleState } from './state'
import { AloDbRole } from '@/models/alodb/AloDbRole'

export class RoleGetter {  
      
  public roles(state:IRoleState,getters:any) {
    return state.roles.filter(r => r.ROL_KEY != "admin")
  }

  public rolesByKey(state:IRoleState) {
    return state.roles.reduce(
      (acc, role) => {
        acc[role.ROL_KEY!] = role
        return acc
      },
      {} as { [key: string]: AloDbRole }
    )
  }

  public rolesById(state:IRoleState) {     
    return state.roles.filter(r => r.ROL_KEY != "admin").reduce((acc,value) =>{
        acc[value.ROL_ID!] = value
        return acc
    },{}  as {[id:number]:AloDbRole})      
  }

  public modifiedAdmRole(state:IRoleState,getters:any) {
    return state.modifiedAdmRole
  }

  public originalAdmRole(state:IRoleState,getters:any) {
    return state.originalAdmRole
  }

  public roleLoading(state:IRoleState,getters:any) {
    return state.roleLoading
  }

  public roleStatus(state:IRoleState) {     
    return state.status
  }

  public adminRoleFilter(state:IRoleState) {     
    return state.adminFilter
  }
  
}

export default util.classToObject(RoleGetter)